import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "./TopicsPage.css";

const TopicsPage = () => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await api.get("topics/");
        const topicsData = Array.isArray(response.data) ? response.data : [];
        setTopics(topicsData);
      } catch (err) {
        console.error(err);
        setError(err.message || "載入主題失敗，請稍後再試。");
        setTopics([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTopics();
  }, []);

  const handleTopicClick = (topicId) => {
    navigate(`/topics/${topicId}`);
  };

  return (
    <div className="topics-page">
      <header className="topics-page-header">
        <h1>探索主題</h1>
        <p>選擇您感興趣的主題，開始探索精彩內容</p>
      </header>

      {loading ? (
        <div className="topics-loading">
          <div className="loading-spinner"></div>
          <p>正在載入主題...</p>
        </div>
      ) : error ? (
        <div className="topics-error">
          <span className="error-icon">!</span>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>重試</button>
        </div>
      ) : topics.length === 0 ? (
        <div className="topics-empty">
          <span className="empty-icon">📭</span>
          <p>目前沒有主題</p>
        </div>
      ) : (
        <div className="topics-grid">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="topic-item"
              onClick={() => handleTopicClick(topic.id)}
            >
              <div className="topic-item-content">
                <div className="topic-item-header">
                  <h2 className="topic-item-name">{topic.name}</h2>
                  {topic.moderator_info && (
                    <span className="topic-item-moderator">
                      {topic.moderator_info.username}
                    </span>
                  )}
                </div>
                <p className="topic-item-description">{topic.description}</p>
                <div className="topic-item-footer">
                  <span className="topic-item-count">
                    {topic.post_count !== undefined ? `${topic.post_count} 篇文章` : ""}
                  </span>
                  <span className="topic-item-arrow">→</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TopicsPage;
